<template>
  <div>
    <nav
      class="top-0 h-[100px] relative z-20 w-full flex flex-wrap navbar-expand-lg items-center bg-white/90 dark:bg-blueDianne/90 backdrop-blur-md shadow-md dark:shadow-[0_4px_20px_-5px_rgba(0,0,0,0.5)] transition-colors duration-300"
    >
      <div
        class="container flex justify-between max-w-full sm:max-w-[1440px] mx-auto h-12 items-center px-5"
      >
        <div class="self-start shrink-0 px-2">
          <router-link
            to="/"
            class="text-sm font-bold leading-relaxed inline-block whitespace-nowrap uppercase"
          >
            <div id="main-logo">
              <div class="flex">
                <span class="left-bracket font-headline">[</span>
                <div>
                  <h1 class="logo-line-1 font-headline">RESEARCH</h1>
                  <h1 class="logo-line-2 font-headline">COMPASS</h1>
                  <div class="ns-logo-holder bg-puertoRico">
                    <img src="/img/notedsource-logo.svg" />
                  </div>
                </div>
                <span class="right-bracket font-headline">]</span>
              </div>
            </div>
          </router-link>
        </div>
        <div class="block sm:hidden">
          <button
            aria-label="Mobile Navigation Menu"
            @click="toggleMobileMenu()"
          >
            <div class="hamburger">
              <div class="hamburger-line"></div>
              <div class="hamburger-line"></div>
              <div class="hamburger-line"></div>
            </div>
          </button>
        </div>
        <div class="hidden sm:block text-blueDianne dark:text-white">
          <div class="flex items-center pl-10">
            <!-- <a :href="`/pricing`">
              <div
                class="flex items-center py-3 cursor-pointer font-headline px-2"
              >
                <h6 class="text-sm">Pricing</h6>
              </div>
            </a> -->
            <template v-if="$store.getters.isCheckingAuth">
              <i class="fas fa-circle-notch fa-spin mr-3 text-blueGray-300"></i>
            </template>
            <template v-else-if="!$store.getters.isPersonLoggedIn">
              <a class="register-button" :href="`/auth/register`">
                <div
                  class="flex items-center mx-3 py-2 cursor-pointer font-headline px-3 bg-white dark:bg-blueDianne border border-black dark:border-white rounded-full"
                >
                  <h6 class="text-sm">Sign&nbsp;Up</h6>
                </div>
              </a>
              <a class="login-button" :href="`/auth/login`">
                <div
                  class="flex items-center mx-3 py-2 cursor-pointer font-headline px-2 text-blueDianne"
                >
                  <h6 class="text-sm">Login</h6>
                </div>
              </a>
            </template>
            <template v-else>
              <div class="mb-3 mt-2 pt-2 hidden md:block ml-5">
                <div
                  v-on-click-outside="closeDesktopMenu"
                  class="mx-auto w-[200px]"
                >
                  <div
                    class="flex items-center justify-between cursor-pointer"
                    @click="toggleDesktopMenu()"
                  >
                    <div class="overflow-x-hidden">
                      <p class="block text-sm">
                        Hello, {{ $store.getters.person.firstName }}
                      </p>
                      <p
                        class="text-xs text-blueGray-400 max-w-full overflow-x-hidden text-ellipsis"
                      >
                        {{ $store.getters.person.calc_EmailAddress }}
                      </p>
                      <p
                        v-if="$store.getters.isImpersonating"
                        class="text-xs text-black hidden sm:block whitespace-nowrap bg-orange-200 px-1 py-0 mb-2 overflow-x-hidden text-ellipsis"
                      >
                        <em
                          >Impersonated by
                          {{ $store.getters.isImpersonating }}</em
                        >
                      </p>
                      <!-- <p
                        class="text-xs inline bg-puertoRico text-blueDianne font-bold px-[3px] py-0 uppercase"
                      >
                        <span v-if="$store.getters.person.subscriptionLevel"
                          >{{
                            $store.getters.person.subscriptionLevel.value
                          }}
                          Plan</span
                        >
                        <span v-else>Trial Plan</span>
                      </p> -->
                    </div>
                    <div class="text-white ml-5">
                      <i
                        v-if="!desktopMenuOpen"
                        class="fa-solid fa-caret-down"
                      ></i>
                      <i
                        v-if="desktopMenuOpen"
                        class="fa-solid fa-caret-up"
                      ></i>
                    </div>
                  </div>
                  <div
                    v-if="desktopMenuOpen"
                    class="absolute text-white border-white shadow-lg border-2 border w-[200px] mt-3"
                  >
                    <a :href="`/auth/logout`">
                      <div
                        class="bg-blueDianne hover:bg-blueDianne-950 flex items-center cursor-pointer py-2 px-3 text-sm"
                      >
                        <h6 class="">Log&nbsp;Out</h6>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </nav>
    <div
      :class="{ 'not-shown': !mobileMenuOpen }"
      class="nav-menu fixed w-[100vh] h-[100vh] top-0 bg-white"
    >
      <div class="absolute left-[calc(100vw_-_100px)] mt-[20px]">
        <a href="#" aria-label="Toggle Mobile Menu" @click="toggleMobileMenu()">
          <div class="hamburger">
            <div class="hamburger-x hamburger-x-left"></div>
            <div class="hamburger-x hamburger-x-right"></div>
          </div>
        </a>
      </div>
      <div class="flex flex-col pt-[150px]">
        <router-link
          to="/"
          class="text-white text-sm font-bold leading-relaxed inline-block whitespace-nowrap uppercase"
        >
          <div id="mobile-logo" class="text-blueDianne">
            <div class="flex">
              <span class="left-bracket font-headline">[</span>
              <div>
                <h1 class="logo-line-1 font-headline">RESEARCH</h1>
                <h1 class="logo-line-2 font-headline">COMPASS</h1>
                <div class="ns-logo-holder bg-puertoRico">
                  <img src="/img/notedsource-logo.svg" />
                </div>
              </div>
              <span class="right-bracket font-headline">]</span>
            </div>
          </div>
        </router-link>
        <router-link to="/" @click="toggleMobileMenu()">
          <div class="flex items-center cursor-pointer mb-5 px-10">
            <span class="text-2xl">Home</span>
          </div>
        </router-link>
        <!-- <router-link to="/pricing" @click="toggleMobileMenu()">
          <div class="flex items-center cursor-pointer mb-5 px-10">
            <span class="text-2xl">Pricing</span>
          </div>
        </router-link> -->
        <template v-if="!$store.getters.isPersonLoggedIn">
          <hr class="mb-4" />
          <a :href="`/auth/register`" @click="toggleMobileMenu()">
            <div class="flex items-center cursor-pointer mb-5 px-10">
              <h6 class="text-2xl rounded-lg">Sign&nbsp;Up</h6>
            </div>
          </a>
          <a :href="`/auth/login`" @click="toggleMobileMenu()">
            <div class="flex items-center cursor-pointer mb-5 px-10">
              <h6 class="text-2xl rounded-lg">Login</h6>
            </div>
          </a>
        </template>
        <template v-else>
          <div
            class="w-full mb-3 mt-2 block md:hidden bg-blueGray-100 py-3 px-10"
          >
            <p
              v-if="$store.getters.isImpersonating"
              class="text-2xl text-black hidden sm:inline-block bg-orange-200 px-1 py-0 mb-2"
            >
              <em>Impersonated by {{ $store.getters.isImpersonating }}</em>
            </p>
            <div class="flex items-center">
              <div class="overflow-x-hidden">
                <p class="block text-2xl">
                  Hello, {{ $store.getters.person.firstName }}
                </p>
                <p
                  class="text-blueGray-400 max-w-full overflow-x-hidden text-ellipsis"
                >
                  {{ $store.getters.person.calc_EmailAddress }}
                </p>
              </div>
            </div>
          </div>
          <a :href="`/auth/logout`" @click="toggleMobileMenu()">
            <div class="flex items-center cursor-pointer mb-5 px-10">
              <h6 class="text-2xl rounded-lg">Log&nbsp;Out</h6>
            </div>
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { vOnClickOutside } from "@vueuse/components";

export default {
  directives: {
    onClickOutside: vOnClickOutside,
  },
  data() {
    return {
      webBaseUrl: import.meta.env.VITE_WEB_BASE_URL,
      adminBaseUrl: import.meta.env.VITE_ADMIN_BASE_URL,
      mobileMenuOpen: false,
      desktopMenuOpen: false,
    };
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    toggleDesktopMenu() {
      this.desktopMenuOpen = !this.desktopMenuOpen;
    },
    closeDesktopMenu() {
      this.desktopMenuOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.hamburger {
  margin: 25px;
  width: 40px;
  top: 5px;
  position: relative;

  .hamburger-line {
    width: 40px;
    height: 5px;
    background-color: #cccccc;
    border-radius: 2px;
    margin-bottom: 8px;
  }

  .hamburger-x {
    width: 40px;
    height: 5px;
    background-color: #bbbbbb;
    border-radius: 2px;
    position: relative;

    &.hamburger-x-left {
      transform: rotate(45deg);
    }
    &.hamburger-x-right {
      transform: rotate(-45deg);
      top: -4px;
    }
  }
}
.nav-menu {
  transition: 0.5s ease-in-out;
  opacity: 1;
  left: 0vh;
  pointer-events: all;
  z-index: 50;

  &.not-shown {
    opacity: 0;
    left: 100vh;
    pointer-events: none;
  }
}
#main-logo {
  position: absolute;
  top: 0px;
  color: rgb(31 69 80);
  .left-bracket,
  .right-bracket {
    font-size: 65px;
  }
  .logo-line-1 {
    text-align: center;
    line-height: 60px;
    text-transform: uppercase;
    font-size: 33px;
  }
  .logo-line-2 {
    text-align: center;
    line-height: 0px;
    text-transform: uppercase;
    font-size: 34px;
  }
  .ns-logo-holder {
    margin-top: 20px;
    padding: 5px 10px;
    border-top-left-radius: 100vh;
    border-bottom-left-radius: 100vh;
    border-bottom-right-radius: 100vh;
  }
}
#mobile-logo {
  position: absolute;
  top: 8px;
  color: rgb(31 69 80);
  left: 28px;
  .left-bracket,
  .right-bracket {
    font-size: 65px;
  }
  .logo-line-1 {
    text-align: center;
    line-height: 60px;
    text-transform: uppercase;
    font-size: 33px;
  }
  .logo-line-2 {
    text-align: center;
    line-height: 0px;
    text-transform: uppercase;
    font-size: 34px;
  }
  .ns-logo-holder {
    margin-top: 20px;
    padding: 5px 10px;
    border-top-left-radius: 100vh;
    border-bottom-left-radius: 100vh;
    border-bottom-right-radius: 100vh;
  }
}
.register-button {
}
.login-button {
  background: var(
    --Gradient,
    linear-gradient(88deg, #e8f5b7 -10.14%, #2dcfae 96.35%)
  );
  border-radius: 100vh;
}
.dark {
  #main-logo,
  #mobile-logo {
    color: white;
  }
}
</style>
